import React from "react";

const Java_Scope = () => {
  return (
    <div>
      <h1>Java Scope</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Scope in Java.</p>
    </div>
  );
};

export default Java_Scope;
